import React, { HTMLAttributes, FC } from "react";

interface IStaticImageProps {
  src?: string;
  src2x?: string;
  src3x?: string;
  alt?: string;
  height?: number | string;
  width?: number | string;
}

const StaticImageComponent: FC<
  IStaticImageProps & HTMLAttributes<HTMLImageElement>
> = (props) => {
  const { src, src2x, src3x, alt, height, width, className, ...otherProps } =
    props;

  const dataSrc = src2x && src3x ? `${src} 1x, ${src2x} 2x, ${src3x} 3x` : src;

  return (
    <img
      {...otherProps}
      data-src={dataSrc}
      srcSet={dataSrc}
      alt={alt}
      height={height}
      width={width}
      className={className}
    />
  );
};

export const StaticImage = React.memo(StaticImageComponent);
